module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_max_graphite.3723e042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_max_graphite.png
// module id = 2097
// module chunks = 0